import { createAsyncThunk } from '@reduxjs/toolkit';
import assetServiceApiInstance from '../../../../config/assetApiConfig';

// Create Asset
export const createAsset = createAsyncThunk(
    'asset/create',
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.post('/assets', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create asset');
        }
    }
);

// Fetch Asset by ID
export const fetchAssetById = createAsyncThunk(
    'asset/fetchById',
    async (assetId: number, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get(`/assets/${assetId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch asset');
        }
    }
);

export const fetchAssetDetailsByAssetId = createAsyncThunk(
    'asset/fetchAssetDetailsByAssetId',
    async ({ assetId }: { assetId: string }, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get(`/asset-data/${assetId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch asset');
        }
    }
);

// Fetch All Assets
export const fetchAllAssets = createAsyncThunk(
    'asset/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get('/assets');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch assets');
        }
    }
);

// Update Asset
export const updateAsset = createAsyncThunk(
    'asset/update',
    async ({ assetId, formData }: any & { assetId: number }, { rejectWithValue }) => {
        try {
            for (let [key, value] of formData.entries()) {
            }

            const response = await assetServiceApiInstance.put(`/assets/${assetId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update asset');
        }
    }
);


// Delete Asset
export const deleteAsset = createAsyncThunk(
    'asset/delete',
    async (assetId: number, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.delete(`/assets/${assetId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete asset');
        }
    }
);

export const fetchAssetSummary = createAsyncThunk(
    'asset/fetchAssetSummary',
    async (_, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get('/asset-summary');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch asset');
        }
    }
);
export const fetchAssetLog = createAsyncThunk(
    'asset/fetchAssetLog',
    async (_, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get('/asset-logs');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch asset');
        }
    }
);


// Get Assets by Employee ID
export const fetchAssetsByEmployeeId = createAsyncThunk(
    'asset/fetchByEmployeeId',
    async (employeeId: number, { rejectWithValue }) => {
        try {
            const response = await assetServiceApiInstance.get(`/assets/employee/${employeeId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch assets by employee ID');
        }
    }
);

//fetch assetRequest by supervisorHierarchy
export const fetchAssetRequestBySupervisorHierarchy = createAsyncThunk(
    'asset/fetchAssetRequestBySupervisorHierarchy',
    async (
        { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
        { rejectWithValue }
    ) => {
        try {
            const response = await assetServiceApiInstance.get(
                `/asset-request/supervisor/${supervisorId}`,
                { params: { includeSelf } }
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data || 'Failed to fetch supervisor hierarchy asset requests'
            );
        }
    }
);

